"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadShiftHistory = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const shiftHistoryQuery = (0, graphql_tag_1.default) `
  query ShiftHistory($id: ID!) {
    shift(id: $id) {
      history {
        type
        diff
        author
        authorName
        created
        data
      }
    }
  }
`;
const loadShiftHistory = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(shiftHistoryQuery, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors, `${(0, util_1.t)('MA_SHIFT')} - ${(0, util_1.t)('HISTORY')}`);
    return data?.shift?.history;
};
exports.loadShiftHistory = loadShiftHistory;
